export const EstadoAprobacionEvaluacion = {
    PENDIENTE: "PENDIENTE",
    APROBADO: "APROBADO",
    PENDIENTE_APROBACION_GH:"PENDIENTE_APROBACION_GH"
}